import { delay } from '../utils/_helperFunction';
import BluetoothTerminal from './BluetoothTerminal'

export default class BluetoothServer extends BluetoothTerminal {
    
    constructor() {
        super();
        this._data = [];
        this._isRead = false;
        this._isConnected = false;
        this.receive = this.receiveData.bind(this);
        this.getCurrentVersion = this.getVersion.bind(this);
        this.setDataToDevice = this.setDataToDevice.bind(this);
        this.count = 10;
    }

    start() {
        return this.connect()
        .then(() => {
            this._isConnected = true;
            console.log('The server is connect to device ', this._device?.name || '')
            return this._device;
        })
    }

    read(seconds) {
        this._isRead = true;
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                this._isRead = false;
                const workData = [...this._data];
                this._data = []
                resolve(workData);
            }, seconds * 1000);    
        });
    }

    async getVersion() {
        if (this.count > 0 && !this._currentVersion) {
            await delay(1000)
            console.log('await delay(1000)', this._currentVersion)
            this.count = this.count  - 1
            //! TEMP FOR TESTING FILE DOWNLOAD
            if (this.count === 2) {
                this._currentVersion = '0.6b96'
            }

            return this.getVersion();
        } else {
            return this._currentVersion
        }
    }
    _readyState() {
        return {
            gattConnected: !!this._device?.gatt?.connected,
            hasCharacteristic: !!this._characteristic,
            hasRxCharacteristic: !!this._rxCharacteristic,
            isSendingData: !!this._isSendingData,
            onboardBlocked: !!this._onboardBlocked,
        };
    }

    // Wait until GATT + characteristics are reattached. The device disconnects
    // briefly after AT#ONBOARD (BLE auto-reset on single-handle firmware); any
    // send during that window fails with "There is no connected device".
    async waitForReady(timeoutMs = 15000) {
        const start = Date.now();
        while (!this.isDeviceReady()) {
            if (Date.now() - start > timeoutMs) return false;
            await delay(200);
        }
        return true;
    }

    // !data is to testing only, then empty array
    async setDataToDevice(cms = ['S', '8', '1', '4'], data, timeMs = 2000) {
        const commands = Array.isArray(cms) ? cms : [];
        const payload = Array.isArray(data) ? data : [];
        let hasError = false;

        // Safety gate: refuse to start if the device is not currently ready.
        // Optimistically queueing commands during the AT#ONBOARD-induced
        // disconnect window leads to silent failures and a confusing 30+s
        // wait followed by an error. Tell the caller (and the UI) right away.
        if (!this.isDeviceReady()) {
            console.log('setDataToDevice REFUSED — device not ready');
            if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('device-busy-reconnecting', {
                    detail: { message: 'Device is reconnecting. Please wait until it reconnects before retrying.' }
                }));
            }
            return false;
        }

        this._isSendingData = true;
        try {
            for (const one of commands) {
                console.log('SEND_TO_DEVICE : ', one)
                if (!this.isDeviceReady()) {
                    console.log('SEND_TO_DEVICE_STOP_ERROR === device disconnected mid-flight');
                    hasError = true;
                    if (typeof window !== 'undefined') {
                        window.dispatchEvent(new CustomEvent('device-busy-reconnecting', {
                            detail: { message: 'Device disconnected during operation. Please wait for reconnect and retry.' }
                        }));
                    }
                    break;
                }
                try {
                    await this.send(one)
                } catch (error) {
                    console.log('SEND_TO_DEVICE_STOP_ERROR === ', error.message || error)
                    hasError = true;
                    break;
                }
                await delay(timeMs)
            }
            if (!hasError) for (const one of payload) {
                console.log('SEND_TO_DEVICE : ', one)
                if (!this.isDeviceReady()) {
                    console.log('SEND_TO_DEVICE_DATA_ERROR === device disconnected mid-flight');
                    hasError = true;
                    break;
                }
                try {
                    await this.send(one)
                } catch (error) {
                    console.log('SEND_TO_DEVICE_DATA_ERROR === ', error.message || error)
                    hasError = true;
                }
                await delay(timeMs)
            }
        } finally {
            this._isSendingData = false;
        }
        return !hasError;
    }

    async receiveData(data) {
        if (this._isRead) {
            this._data.push(data);
        }
    }
    getDevice() {
        return this._device;
    }

    isDeviceReady() {
        return Boolean(
            this._device?.gatt?.connected &&
            this._characteristic &&
            this._rxCharacteristic
        );
    }

    waitForOnboardingCompleted(timeoutMs = 30000) {
        // If onboarding already completed during setDataToDevice, resolve immediately
        if (this._onboardBlocked) {
            return Promise.resolve(true);
        }
        return new Promise((resolve) => {
            const timer = setTimeout(() => {
                this._onboardCompleteResolve = null;
                console.log('waitForOnboardingCompleted: TIMEOUT — device did not confirm completion');
                resolve(false);
            }, timeoutMs);

            this._onboardCompleteResolve = (result) => {
                clearTimeout(timer);
                resolve(result);
            };
        });
    }

    async sendCommand(key, ms = 3000) {
        if (!key) {
            return
        }
        console.log('sendCommand to device === ', key)
        if (!this.isDeviceReady()) {
            console.log('sendCommand REFUSED — device not ready');
            if (typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('device-busy-reconnecting', {
                    detail: { message: 'Device is reconnecting. Please wait before retrying.' }
                }));
            }
            return false;
        }
        await this.send(key)
        await delay(ms)
        return true;
    }
}

